import { render, staticRenderFns } from "./FooterLegality.vue?vue&type=template&id=95cc7066&scoped=true&"
import script from "./FooterLegality.vue?vue&type=script&lang=js&"
export * from "./FooterLegality.vue?vue&type=script&lang=js&"
import style0 from "./FooterLegality.vue?vue&type=style&index=0&id=95cc7066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cc7066",
  null
  
)

export default component.exports